module.exports = "<form [formGroup]=\"form\">\r\n  <input\r\n    type=\"text\"\r\n    formControlName=\"phone\"\r\n    [disabled]=\"disabled\"\r\n    [textMask]=\"{ mask: MASK_PHONE }\"\r\n    [required]=\"isRequired\"\r\n    [placeholder]=\"placeholder ? placeholder : ''\"\r\n  >\r\n</form>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/phone-number/component/input-phone-number/input-phone-number.component.html
// module id = 2623
// module chunks = 66